import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/600.css';
import '@fontsource/instrument-sans/500.css';
import '@fontsource/instrument-sans/600.css';
import '@fontsource/instrument-sans/700.css';
import './styles.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { AppErrorBoundary } from './components/shell/CrashScreen';
import { env } from './env';
import { initObservability } from './lib/observability';

async function bootstrap() {
  if (env.mock) {
    const { startMocks } = await import('./mocks/browser');
    await startMocks();
  }
  // Sentry samo kad je VITE_SENTRY_DSN postavljen (inače bez učitavanja SDK-a i bez mrežnih poziva).
  await initObservability().catch(() => undefined);
  const el = document.getElementById('root');
  if (!el) throw new Error('#root nije pronađen');
  createRoot(el).render(
    <StrictMode>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </StrictMode>,
  );
}

void bootstrap();
